// SPA bo'lgani uchun har bir route almashganda <head> teglarini qo'lda
// yangilaymiz: title, description, canonical, hreflang, robots, OG, Twitter.
// Ochiq (indekslanadigan) sahifalar SEO_ROUTES ro'yxatida; qolgan barcha
// route'lar shaxsiy kabinetga tegishli va noindex bilan beriladi.

import {
  LOCALES,
  DEFAULT_LOCALE,
  localeInfo,
  stripLangPrefix,
  withLangPrefix,
} from "./i18n-routing";

export const SITE_ORIGIN = "https://govcontrol.uz";
// logo.png — 256x256. TODO: 1200x630 o'lchamli public/og-image.png yaratilsa,
// shu yerga o'tkazilsin va twitter:card "summary_large_image" ga qaytarilsin.
export const DEFAULT_OG_IMAGE = SITE_ORIGIN + "/logo.png";

// route.name -> lang faylidagi seo.* kaliti. Bu yerda yo'q route noindex.
const SEO_ROUTES = {
  Home: "home",
  News: "news",
  controlfunction: "controlfunction",
  mandatoryrequirement: "mandatoryrequirement",
  inspectionbooknew: "inspectionbooknew",
  BiznesHimoya: "bizneshimoya",
  Support: "support",
  Login: "login",
  Register: "register",
  Oferta: "oferta",
  Privacy: "privacy",
};

function upsertMeta(attr, name, content) {
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]:not([hreflang])`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// hreflang teglari har sahifada boshqacha bo'lgani uchun eskilarini olib
// tashlab, qaytadan quyamiz.
function replaceAlternates(basePath, indexable) {
  const old = document.head.querySelectorAll("link[rel='alternate'][hreflang]");
  for (let i = 0; i < old.length; i++) old[i].remove();
  if (!indexable) return;

  const add = (hreflang, href) => {
    const el = document.createElement("link");
    el.setAttribute("rel", "alternate");
    el.setAttribute("hreflang", hreflang);
    el.setAttribute("href", href);
    document.head.appendChild(el);
  };

  Object.keys(LOCALES).forEach((key) => {
    add(LOCALES[key].hreflang, SITE_ORIGIN + withLangPrefix(basePath, key));
  });
  // Til aniqlanmagan foydalanuvchilar uchun — standart til versiyasi.
  add("x-default", SITE_ORIGIN + withLangPrefix(basePath, DEFAULT_LOCALE));
}

export function applyRouteMeta(route, i18n) {
  const key = SEO_ROUTES[route.name];
  const siteName = i18n.t("seo.siteName");
  const indexable = !!key;
  const locale = i18n.locale;

  const title = indexable
    ? i18n.t(`seo.${key}.title`)
    : `${siteName} — ${i18n.t("seo.cabinet")}`;
  const description = indexable
    ? i18n.t(`seo.${key}.description`)
    : i18n.t("seo.defaultDescription");

  document.title = title;
  document.documentElement.setAttribute("lang", localeInfo(locale).htmlLang);
  upsertMeta("name", "description", description);
  upsertMeta(
    "name",
    "robots",
    indexable ? "index, follow, max-image-preview:large" : "noindex, nofollow"
  );

  // Query/hash SEO uchun ahamiyatsiz — canonical faqat path bo'yicha.
  const basePath = stripLangPrefix(route.path);
  const canonical = SITE_ORIGIN + withLangPrefix(basePath, locale);
  upsertLink("canonical", canonical);
  replaceAlternates(basePath, indexable);

  upsertMeta("property", "og:type", "website");
  upsertMeta("property", "og:site_name", siteName);
  upsertMeta("property", "og:title", title);
  upsertMeta("property", "og:description", description);
  upsertMeta("property", "og:url", canonical);
  upsertMeta("property", "og:image", DEFAULT_OG_IMAGE);
  upsertMeta("property", "og:locale", localeInfo(locale).ogLocale);

  upsertMeta("name", "twitter:card", "summary");
  upsertMeta("name", "twitter:title", title);
  upsertMeta("name", "twitter:description", description);
  upsertMeta("name", "twitter:image", DEFAULT_OG_IMAGE);
}

export default {
  install(Vue, { router, i18n }) {
    // afterEach — guard i18n.locale ni URL bo'yicha sozlab bo'lgandan keyin.
    router.afterEach((to) => {
      applyRouteMeta(to, i18n);
    });
  },
};
